import { render, staticRenderFns } from "./DetailGrid.vue?vue&type=template&id=3161c2ae&scoped=true"
import script from "./DetailGrid.vue?vue&type=script&lang=ts"
export * from "./DetailGrid.vue?vue&type=script&lang=ts"
import style0 from "./DetailGrid.vue?vue&type=style&index=0&id=3161c2ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3161c2ae",
  null
  
)

export default component.exports